module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('selector', {
    attrs: {
      "draggable-group": "questions",
      "item-name-plural": "questions",
      "item-name": "question",
      "can-add": true,
      "category-list": _vm.questionCategoryWithQuestionsList,
      "disabled-ids": _vm.selectorDisabledQuestionIds,
      "is-fixed": _vm.isFixed,
      "is-editable": _vm.isEditable,
      "search-text": _vm.selectorQuestionSearchText,
      "selected-category-id": _vm.selectorSelectedQuestionCategory
    },
    on: {
      "onItemAdd": _vm.handleAddQuestion,
      "onItemEdit": _vm.handleEditQuestion,
      "onChangeCategory": _vm.handleSelectCategory,
      "onCreate": _vm.handleCreateQuestion,
      "onLoadMore": _vm.handleLoadMore,
      "onResetFilters": _vm.handleResetFilters,
      "onChangeSearchText": _vm.handleSearchText
    },
    model: {
      value: (_vm.questions),
      callback: function($$v) {
        _vm.questions = $$v
      },
      expression: "questions"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72fb4f30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/selectors/QuestionSelector.vue
// module id = 3339
// module chunks = 3